import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import { JlifeAuthorize } from 'api/general/models';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<JlifeAuthorize>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const jlifeAuthorizeReducer = createReducer<State, Actions>(initialState, {
  [actions.jlifeAuthorize.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.jlifeAuthorize.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.jlifeAuthorize.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.jlifeAuthorize.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default jlifeAuthorizeReducer;
